<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/cover.jpg')" alt="Nature" class="page__cover" />
    <div class="block-title">
      <h4>Bienvenido a</h4>
      <h4>CTT Express</h4>
      <p class="mt-32 pt-20 h1--bold h1-subtitle">
        Oferta especial de servicios:
      </p>
      <p class="text-center mt-5 h1--bold primary-color h1-client">
        {{ clientData.businessName }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'Cover',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    clientData() {
      return this[GET_OFFER_ITEM]('client')
    },
  },
}
</script>
